import localStore, { AUTHORIZATION } from '@/store/local-store';
import { emitter, EMITTER_TYPE } from '@/store/mitt';
import axios, { AxiosResponse } from 'axios';

// 定义通用的响应接口
export interface StdResponse<T = any> extends AxiosResponse<T> {
    message: string
}

// 状态码定义
// const codeMessage = {
//     200: 'ok',
//     400: '请求数据错误',
//     401: '用户没有权限',
//     404: '请求的资源不存在',
//     500: '服务器异常',
//     503: '服务器过载或维护',
//     504: '网关超时',
// }

// 创建 Axios 实例，配置基础 URL 和超时时间
const coreAxios = axios.create({
    baseURL: '/api-teamerp', // 用于统一接口前缀
    timeout: 60000, // 请求超时时间（60秒）
});

// 请求拦截器，用于在请求发送前统一处理
coreAxios.interceptors.request.use(
    config => {
        // 从本地localStore获取token
        let token = localStore.token;
        config.headers.token = token;
        return config;
    },
    err => {
        console.log(err);
    }
)
// const appVersion = __APP_VERSION__; // 获取构建时的版本号
// coreAxios.defaults.headers.common['X-App-Version'] = appVersion;

// 响应拦截器，用于在响应返回后统一处理
coreAxios.interceptors.response.use(
    response => {
        // const serverVersion = response.headers['x-app-version'];
        // if (serverVersion && serverVersion !== appVersion) {
        //     // 版本不一致，触发更新提示逻辑
        //     promptUserToUpdate();
        // }
        if (response.headers['content-type']?.indexOf('application/json') >= 0) {
            return response.data;
        }
        return response;
    },
    (err) => {
        const error = err.response;
        if (!error) {
            return Promise.reject("发生其他异常");
        }
        if (error.status === 401) {
            // 未授权登录
            localStore.clear();
            emitter.emit(EMITTER_TYPE.UN_AUTHORIZED);
        }
        return Promise.reject(error);
    }
)

// function promptUserToUpdate() {
//     // 显示一个自定义的弹窗，提示用户更新
//     const updateConfirmed = window.confirm('有新的版本可用，请刷新页面以应用最新更新！');
//     if (updateConfirmed) {
//         window.location.reload(); // 刷新页面应用最新版本
//     }
// }

const feedbackAxios = axios.create({
    baseURL: '/api-das',
    timeout: 60000,
})

feedbackAxios.interceptors.request.use(
    config => {
        // 从本地Cookie获取token
        let token = localStore.token;
        config.headers.token = token;
        return config;
    },
    err => {
        console.log(err);
    }
)
feedbackAxios.interceptors.response.use(
    response => {
        if (response.headers['content-type']?.indexOf('application/json') >= 0) {
            return response.data;
        }
        return response;
    },
    (err) => {
        const error = err.response;
        if (!error) {
            return Promise.reject("发生其他异常");
        }
        console.log(err);

        if (error.status === 401) {
            // 未授权登录
            // localStore.clear();
            // store.userStore.setIsLogin(false);
        }
        return Promise.reject(error);
    }
)


// const standardAxios = axios.create({
//     baseURL: '/api-standard',
//     timeout: 60000,
// })

// standardAxios.interceptors.request.use(
//     config => {
//         // 永久用户token，无需登录，与tnstandard-mui一致
//         let token = "579c0b005d4547de9f57ea9b6f984107";
//         config.headers.token = token;
//         return config;
//     },
//     err => {
//         console.log(err);
//     }
// )
// standardAxios.interceptors.response.use(
//     response => {
//         if (response.headers['content-type']?.indexOf('application/json') >= 0) {
//             return response.data;
//         }
//         return response;
//     },
//     (err) => {
//         const error = err.response;
//         if (!error) {
//             return Promise.reject("发生其他异常");
//         }
//         console.log(err);

//         if (error.status === 401) {
//             // 未授权登录
//             // localStore.clear();
//             // store.userStore.setIsLogin(false);
//         }
//         return Promise.reject(error);
//     }
// )

const monixAxios = axios.create({
    baseURL: '/api',
    timeout: 60000,
})

monixAxios.interceptors.request.use(
    config => {
        // 永久用户token，无需登录，与monix-mui一致
        let token = "579c0b005d4547de9f57ea9b6f984107";
        config.headers.token = token;
        return config;
    },
    err => {
        console.log(err);
    }
)
monixAxios.interceptors.response.use(
    response => {
        if (response.headers['content-type']?.indexOf('application/json') >= 0) {
            return response.data;
        }
        return response;
    },
    (err) => {
        const error = err.response;
        if (!error) {
            return Promise.reject("发生其他异常");
        }
        console.log(err);

        if (error.status === 401) {
            // 未授权登录
            // localStore.clear();
            // store.userStore.setIsLogin(false);
        }
        return Promise.reject(error);
    }
)


export { coreAxios, feedbackAxios, monixAxios };
